import { BagsECrediarioDoCliente, TotalPorLojaEGrupoDoCliente } from '../models/PainelDoCliente'
import { formatarReais, TEXTO_SEM_DADOS } from './painel-do-cliente-shareds'

const COR_DO_CREDIARIO_LIVRE = '#2E7D32'
const COR_DO_EM_ABERTO = '#FB8C00'
const COR_DO_TITULO_EM_ATRASO = '#D32F2F'

export type ChaveDoBlocoDeBags = 'bags' | 'crediarioLivre' | 'emAberto' | 'titulosEmAtraso'

export interface BlocoDeBagsECrediario {
	chave: ChaveDoBlocoDeBags
	icone: string
	titulo: string
	valor: string
	detalhe: string
	cor: string | null
}

function temValor(valor: number | null | undefined): valor is number {
	return valor !== null && valor !== undefined
}

function detalheDeLojaEGrupo(
	total: TotalPorLojaEGrupoDoCliente | null | undefined,
	formatar: (valor: number) => string,
	separadorDoRotulo: string,
): string {
	if (!total || !temValor(total.loja) || !temValor(total.grupo)) return ''
	return `Loja${separadorDoRotulo} ${formatar(total.loja)} · Grupo${separadorDoRotulo} ${formatar(total.grupo)}`
}

export function textoDeTitulos(quantidade: number): string {
	return `${quantidade} ${quantidade === 1 ? 'título' : 'títulos'}`
}

function blocoDeBags(dados: BagsECrediarioDoCliente | null): BlocoDeBagsECrediario {
	const total = dados?.bags?.total
	return {
		chave: 'bags',
		icone: 'mdi-shopping',
		titulo: 'Bags em aberto',
		valor: temValor(total) ? String(total) : TEXTO_SEM_DADOS,
		detalhe: detalheDeLojaEGrupo(dados?.bags, quantidade => String(quantidade), ':'),
		cor: null,
	}
}

function blocoDeCrediarioLivre(dados: BagsECrediarioDoCliente | null): BlocoDeBagsECrediario {
	const limite = dados?.crediario?.limite
	return {
		chave: 'crediarioLivre',
		icone: 'mdi-credit-card',
		titulo: 'Crediário livre',
		valor: formatarReais(dados?.crediario?.livre),
		detalhe: temValor(limite) ? `Limite ${formatarReais(limite)}` : '',
		cor: COR_DO_CREDIARIO_LIVRE,
	}
}

function blocoDeEmAberto(dados: BagsECrediarioDoCliente | null): BlocoDeBagsECrediario {
	const emAberto = dados?.emAberto
	return {
		chave: 'emAberto',
		icone: 'mdi-alert-circle',
		titulo: 'Em aberto (c/ juros)',
		valor: formatarReais(emAberto?.total),
		detalhe: detalheDeLojaEGrupo(emAberto, formatarReais, ''),
		cor: COR_DO_EM_ABERTO,
	}
}

function blocoDeTitulosEmAtraso(dados: BagsECrediarioDoCliente | null): BlocoDeBagsECrediario {
	const quantidade = dados?.titulosEmAtraso?.quantidade
	const temAtraso = temValor(quantidade) && quantidade > 0
	return {
		chave: 'titulosEmAtraso',
		icone: 'mdi-calendar-alert',
		titulo: 'Títulos em atraso',
		valor: formatarReais(dados?.titulosEmAtraso?.valor),
		detalhe: temValor(quantidade) ? textoDeTitulos(quantidade) : '',
		cor: temAtraso ? COR_DO_TITULO_EM_ATRASO : null,
	}
}

export function montarBlocosDeBagsECrediario(dados: BagsECrediarioDoCliente | null): BlocoDeBagsECrediario[] {
	return [
		blocoDeBags(dados),
		blocoDeCrediarioLivre(dados),
		blocoDeEmAberto(dados),
		blocoDeTitulosEmAtraso(dados),
	]
}
